import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { css } from 'emotion'
import * as React from 'react'

import { getContrastingColor } from 'embed/utils'

import Spinner from 'embed/components/LoadingIndicator/Spinner'

const styles = require('./styles')

export interface ButtonProps {
  className?: string
  disabled?: boolean
  loading?: boolean
  onClick: () => void
}

export const Button: React.FC<ButtonProps> = ({ children, className, disabled, loading, onClick }) => (
  <ThemeConsumer>
    {({ colorPrimary, colorTextPrimary, borderRadiusSmall, fontFamilyPrimary }) => (
      <button
        className={classnames(
          styles.button,
          css(`
            background-color: ${colorPrimary};
            color: ${getContrastingColor(colorPrimary, { black: colorTextPrimary })};
            border-radius: ${borderRadiusSmall};
            font-family: ${fontFamilyPrimary};
            &:hover {opacity: 0.84;}
          `),
          className,
        )}
        disabled={disabled || loading}
        onClick={onClick}
      >
        {children}
        {loading && (
          <div className={styles.spinnerContainer}>
            <Spinner className={styles.spinner} />
          </div>
        )}
      </button>
    )}
  </ThemeConsumer>
)
